import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { ScormState, ScormTypes } from './types';

const INITIAL_STATE: ScormState = {
    data: undefined,
    loading: false,
    hasError: false,
    error: undefined,
    success: false,
};

const reducer: Reducer<ScormState> = (state: ScormState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case ScormTypes.START_CDN_TEST_REQUEST:
            return { ...state, loading: true };
        case ScormTypes.START_CDN_TEST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.url ? action.payload.url : action.payload,
            };
        case ScormTypes.START_CDN_TEST_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
                error: action.payload,
                data: '',
            };
        case ScormTypes.START_CDN_TEST_CLEAR:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default reducer;
